'use client';

import cx from 'classnames';
import { FC } from 'react';

import { Avatar } from '@/components/Avatar';
import { useTimeAgo } from '@/hooks/useTimeAgo';
import rolliNewsLogo from '@/images/icon_rollinews.png';
import { formatMessagesText } from '@/utils/formatMessagesText';

import styles from './NotificationRow.module.scss';
import { InotificationRow } from './NotificationRow.types';
import { NotificationRowAction } from './NotificationRowAction';

export const NotificationRow: FC<InotificationRow> = ({
  content,
  wasRead,
  created,
  action,
  onClick,
}) => {
  const createdFormattedTime = useTimeAgo(created);
  const { textFormatted, lastUserName } = formatMessagesText(content);

  return (
    <div
      className={cx(styles.container, { [styles.read]: wasRead })}
      onClick={onClick}
    >
      <div className={styles.rowContent}>
        <Avatar
          userName={lastUserName ?? ''}
          url={!lastUserName ? rolliNewsLogo.src : ''}
        />
        <div className={styles.content}>
          <span className={styles.text}>{textFormatted}</span>
          <span className={styles.created}>Hace {createdFormattedTime}</span>
        </div>
        {!lastUserName && (
          <div>
            <NotificationRowAction {...action} />
          </div>
        )}
      </div>
    </div>
  );
};
